// src/store/onlineStatusSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OnlineStatusState {
  isOnline: boolean;
  lastCheck: string | null;
}

const initialState: OnlineStatusState = {
  isOnline: false,
  lastCheck: null
};

const onlineStatusSlice = createSlice({
  name: 'onlineStatus',
  initialState,
  reducers: {
    setOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
      state.lastCheck = new Date().toISOString();
    }
  }
});

export const { setOnlineStatus } = onlineStatusSlice.actions;
export default onlineStatusSlice.reducer;